<template>
  <div id>
    <div class="commodityHead row" style="padding-bottom:0;height:40px;">
      <el-breadcrumb class="elArrowText" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a @click="jumpTT('/invoicingFather/invoicingSet')" href="javascript:;">供应商管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item v-if="isAddSupplier">新建供应商</el-breadcrumb-item>
        <el-breadcrumb-item v-if="!isAddSupplier">编辑供应商</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="from" style="margin-top:20px;">
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="100px"
        hide-required-asterisk
        label-position="right"
      >
        <el-form-item label="名称" prop="supplierName">
          <el-input v-model="form.supplierName"></el-input>
        </el-form-item>
        <!-- <el-form-item label="编号" prop="supplierCode">
          <el-input v-model="form.supplierCode"></el-input>
        </el-form-item> -->
        <el-form-item label="分类" prop="supplierClassificationId">
          <el-select v-model="form.supplierClassificationId" placeholder="请选择活动区域">
            <el-option
              v-for="item in options"
              :key="item.supplierClassificationId"
              :label="item.supplierClassificationName"
              :value="item.supplierClassificationId"
            ></el-option>
          </el-select>
          <el-button type="primary" plain @click="jumpTT('/invoicingFather/addClassify')">添加分类</el-button>
        </el-form-item>
        <el-form-item label="联系人" prop="supplierLink">
          <el-input v-model="form.supplierLink"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="supplierTel">
          <el-input v-model="form.supplierTel" @blur="phoneBlur"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="supplierAddress">
          <el-input v-model="form.supplierAddress"></el-input>
        </el-form-item>
        <el-form-item label="默认供应商">
          <el-switch v-model="form.isDefault"></el-switch>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')" v-if="isAddSupplier">完成</el-button>
          <el-button type="primary" @click="submitForm2('form')" v-if="!isAddSupplier">完成修改</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {
  saveSupplier,
  supplierClassificationList,
  modifySupplier
} from "../api";
export default {
  data() {
    return {
      isAddSupplier: true,
      form: {
        supplierName: "",
        supplierCode: "",
        supplierClassificationId: null,
        supplierLink: "",
        supplierTel: "",
        supplierAddress: "",
        isDefault: true,
        remark: ""
      },
      rules: {
        supplierName: [
          { required: true, message: "请输入名称", trigger: "blur" }
          //   { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        supplierCode: [
          { required: true, message: "请输入正确编号", trigger: "blur" }
        ],
        supplierClassificationId: [
          { required: true, message: "请输入分类", trigger: "blur" }
        ],
        supplierLink: [
          { required: true, message: "请输入联系人", trigger: "blur" }
        ],
        supplierTel: [
          {
            required: true,
            // min: 11,
            // max: 11,
            message: "请输入正确电话",
            trigger: "blur",
            // pattern: /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/ || /^1[34578]\d{9}$/
          }
        ],
        supplierAddress: [
          { required: true, message: "请输入地址", trigger: "blur" }
        ]
      },
      options: [],
      userList: [],
      shopInformation: []
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    this.supplierClassificationList();
    if (this.$route.query.arr) {
      // this.isAdd = this.$route.query.docId;
      console.log(this.$route.query.arr, "this.$route.query.docId");
      if (this.$route.query.type == "edit") {
        this.isAddSupplier = false;
      }
      this.form = JSON.parse(this.$route.query.arr);
      console.log(this.form.isDefault, "111");
      if (this.form.isDefault == 1) {
        this.form.isDefault = true;
      } else {
        this.form.isDefault = false;
      }
    }
  },
  methods: {
    phoneBlur(e) {
      let reg1 = /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/
      let reg = /^1[34578]\d{9}$/
      if (!reg.test(e.target.value) && !reg1.test(e.target.value)) {
        this.$message.error("请输入正确的联系方式")
      }
    },
    //供应商分类列表
    supplierClassificationList(e) {
      supplierClassificationList({
        userId: this.userList.id, //用户Id
        sessionId: this.userList.sessionId,
        pageNo: 1,
        row: 999
      })
        .then(res => {
          if (res.code == 1) {
            this.options = res.data;
            console.log(this.options, "供应商分类列表");
            this.form.supplierClassificationId = res.data[0].supplierClassificationId
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(res => {
          console.log("error");
        });
    },
    //跳转
    jumpTT(adress, message) {
      // this.$router.push(adress)
      this.$router.push({ path: adress, query: { docId: message } });
    },
    submitForm(formName) {
      let reg1 = /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/
      let reg = /^1[34578]\d{9}$/
      if (!reg.test(this.form.supplierTel) && !reg1.test(this.form.supplierTel)) {
        this.$message.error("请输入正确的联系方式")
        return
      }
      console.log(this.form, "form");
      this.$refs[formName].validate(valid => {
        if (valid) {
          var list = this.form;
          if (list.isDefault) {
            list.isDefault = 1;
          } else {
            list.isDefault = 0;
          }
          console.log(this.form);
          saveSupplier({
            sessionId: this.userList.sessionId,
            userId: this.userList.id,
            supplierName: list.supplierName,
            supplierCode: list.supplierCode,
            supplierClassificationId: list.supplierClassificationId,
            supplierLink: list.supplierLink,
            supplierTel: list.supplierTel,
            supplierAddress: list.supplierAddress,
            isDefault: list.isDefault,
            // isDefault: 0,
            remark: list.remark
          })
            .then(res => {
              console.log(res, "saveSupplier");
              
              if (res.code == 1) {
                this.$router.push({ path: "/invoicingFather/invoicingSet" });
                this.$message({
                type: "success",
                message: "添加成功",
              });
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(err => {
              console.log(err, "err");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //修改
    submitForm2(formName) {
      let reg1 = /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/
      let reg = /^1[34578]\d{9}$/
      if (!reg.test(this.form.supplierTel) && !reg1.test(this.form.supplierTel)) {
        this.$message.error("请输入正确的联系方式")
        return
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          var list = this.form;
          if (list.isDefault) {
            list.isDefault = 1;
          } else {
            list.isDefault = 0;
          }
          console.log(this.form);
          modifySupplier({
            sessionId: this.userList.sessionId,
            userId: this.userList.id,
            supplierId: list.supplierId,
            supplierName: list.supplierName,
            supplierCode: list.supplierCode,
            supplierClassificationId: list.supplierClassificationId,
            supplierLink: list.supplierLink,
            supplierTel: list.supplierTel,
            supplierAddress: list.supplierAddress,
            isDefault: list.isDefault,
            // isDefault: 0,
            remark: list.remark
          })
            .then(res => {
              console.log(res, "edit");
              if (res.code == 1) {
                  this.$router.push({ path: "/invoicingFather/invoicingSet" });
              this.$message({
                type: "success",
                message: "修改成功"
              });
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch(err => {
              console.log(err, "err");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.from {
  box-sizing: border-box;
  width: 500px;
  padding: 35px 0 0 20px;
  /* overflow-y: scroll; */
  /* height: 910px; */
  position: absolute;
  top: 80px;
}
.commodityHead {
  box-sizing: border-box;
  width: 100%;
  padding: 15px 20px 15px 30px;
  background: #f8f8f8;
  height: 60px;
  position: fixed;
  top: 50px;
  z-index: 100;
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #eeeeee;
}
</style>


// WEBPACK FOOTER //
// src/components/page/editSupplier.vue